type YunoErrorData = {
  provider?: string
  paymentCreated?: boolean
}

export const shouldSkipContinuePayment = (
  err: string,
  data?: YunoErrorData,
): boolean => {
  if (err !== 'CANCELED_BY_USER') return false

  const providerAlwaysPays =
    data?.provider === 'PAYPAL' || data?.provider === 'PAYPAL_ENROLLMENT'

  if (providerAlwaysPays) return false

  const applePayCreated =
    data?.provider === 'APPLE_PAY' && data?.paymentCreated

  return !applePayCreated
}
